/* CSS */
import styles from './ContextMenuManager.module.css';
import shared from '../../styles/shared.module.css';

/* Confirmation modal */
import ConfirmationModal from '../cards/ConfirmationModal';

/* Context */
import { useTripContext } from './TripContext';

/* Hooks */
import { useIsTouch } from '../../hooks/useMediaQuery';

/* Icons */
import tick_icon_filled_black from '../../assets/icons/tick_icon_filled_black.svg';
import change_type_arrow from '../../assets/icons/change_type_arrow.svg';

const ContextMenuManager = ({ itineraryActions, FIELD_OPTIONS }) => {

    // Grab the data from context
    const { itineraryDays } = useTripContext();
    const isTouch = useIsTouch();

    // Grab all the state and functions from the hook we pass in
    const {
        contextMenu, setContextMenu,
        clipboard,
        pendingAction, setPendingAction,
        nameConflict, setNameConflict,
        handleTypeSelect, getScopeModalText,
        initiateAction, executeScopeAction,
        performCopyRow, performCopyColumn
    } = itineraryActions;

    const modalText = getScopeModalText();

    return (
        <>
            {/* CONTEXT MENU */}
            {contextMenu && contextMenu.visible && (
                <div
                    data-context-menu
                    className={styles.contextMenu}
                    style={{ top: contextMenu.y, left: contextMenu.x }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {contextMenu.type === 'row' ? (
                        <>
                            <div className={styles.contextMenuItem} onClick={() => initiateAction('ADD_ROW')}>Add Row</div>
                            <div className={styles.contextMenuItem} onClick={() => initiateAction('DUPLICATE_ROW')}>Duplicate Row</div>
                            <div className={styles.contextMenuSeparator}></div>
                            <div className={styles.contextMenuItem} onClick={performCopyRow}>Copy</div>
                            <div className={`${styles.contextMenuItem} ${(!clipboard || clipboard.type !== 'row') ? styles.disabled : ''}`} onClick={() => initiateAction('PASTE_ROW')}>Paste Row</div>
                            <div className={styles.contextMenuSeparator}></div>
                            <div className={styles.contextMenuItem} onClick={() => initiateAction('CLEAR_ROW')}>Clear Row</div>
                            <div className={`${styles.contextMenuItem} ${styles.danger}`} onClick={() => initiateAction('DELETE_ROW')}>Delete Row</div>
                        </>
                    ) : (
                        <>
                            <div className={styles.contextMenuInputWrapper}>
                                <input
                                    type="text"
                                    className={styles.contextMenuInput}
                                    value={contextMenu.tempLabel}
                                    onChange={(e) => setContextMenu(prev => ({ ...prev, tempLabel: e.target.value }))}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            if (contextMenu.tempLabel.trim()) {
                                                initiateAction('RENAME_COLUMN', { newName: contextMenu.tempLabel });
                                            }
                                        }
                                        if (e.key === 'Escape') {
                                            setContextMenu(null);
                                        }
                                        e.stopPropagation();
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    autoFocus={!isTouch}
                                />
                            </div>
                            <div className={styles.contextMenuItem} onClick={() => initiateAction('ADD_COLUMN')}>Add Column</div>

                            {/* Change type submenu */}
                            <div className={`${styles.contextMenuItem} ${styles.hasSubmenu}`}>
                                <span>Change Type</span>
                                <img src={change_type_arrow} alt="Change Type Icon" className={styles.contextMenuChangeTypeIcon} />

                                <div className={styles.submenu}>
                                    {FIELD_OPTIONS.map((option) => {

                                        const currentDay = itineraryDays[contextMenu.dayIndex];
                                        const currentCol = currentDay?.columns.find(c => c.id === contextMenu.targetId);
                                        const currentType = currentCol?.type || 'text';

                                        const isSelected = option.id === currentType;

                                        return (
                                            <div
                                                key={option.id}
                                                className={styles.submenuItem}
                                                onClick={() => handleTypeSelect(option.id)}
                                            >
                                                <span>{option.label}</span>
                                                {isSelected && (
                                                    <img
                                                        src={tick_icon_filled_black}
                                                        alt="Selected"
                                                        className={styles.submenuItemTick}
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className={styles.contextMenuItem} onClick={() => initiateAction('DUPLICATE_COLUMN')}>Duplicate Column</div>
                            <div className={styles.contextMenuSeparator}></div>
                            <div className={styles.contextMenuItem} onClick={performCopyColumn}>Copy</div>
                            <div className={`${styles.contextMenuItem} ${(!clipboard || clipboard.type !== 'col') ? styles.disabled : ''}`} onClick={() => initiateAction('PASTE_COLUMN')}>Paste Column</div>
                            <div className={styles.contextMenuSeparator}></div>
                            <div className={`${styles.contextMenuItem} ${styles.danger}`} onClick={() => initiateAction('DELETE_COLUMN')}>Delete Column</div>
                        </>
                    )}
                </div>
            )}

            {/* --- MODAL 1: SCOPE SELECTION MODAL --- */}
            <ConfirmationModal
                isOpen={!!pendingAction}
                title={modalText.title}
                message={modalText.message}

                onClose={() => setPendingAction(null)}
                showCancel={false}
                customActions={
                    <div className={shared.modalScopeActions}>
                        <button
                            onClick={() => setPendingAction(null)}
                            className={`${shared.modalButton} ${shared.ghost}`}
                        >
                            Cancel
                        </button>

                        <button
                            onClick={() => executeScopeAction('SINGLE')}
                            className={`${shared.modalButton} ${shared.primary}`}
                        >
                            This Day Only
                        </button>

                        <button
                            onClick={() => executeScopeAction('ALL')}
                            className={`${shared.modalButton} ${shared.primary}`}
                        >
                            All Days
                        </button>
                    </div>
                }
            />

            {/* --- MODAL 2: ERROR MODAL FOR RENAMING CONFLICT --- */}
            <ConfirmationModal
                isOpen={nameConflict.visible}
                onClose={() => setNameConflict({ ...nameConflict, visible: false })}
                onConfirm={() => setNameConflict({ ...nameConflict, visible: false })}
                title="Duplicate Column Name"
                message={nameConflict.message}
                confirmText="Okay"
                showCancel={false}
                isDanger={true}
            />
        </>
    );
};

export default ContextMenuManager;
